export enum QuestionType {
  LIKERT_SCALE = "LIKERT_SCALE",
  OPEN = "OPEN",
  POLAR = "POLAR",
  SELECT = "SELECT"
}
